import { render } from "./OrderItemPriceTable.vue?vue&type=template&id=628fa60c"
import script from "./OrderItemPriceTable.vue?vue&type=script&lang=js"
export * from "./OrderItemPriceTable.vue?vue&type=script&lang=js"

import "./OrderItemPriceTable.vue?vue&type=style&index=0&id=628fa60c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable});
